exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-succes-js": () => import("./../../../src/pages/succes.js" /* webpackChunkName: "component---src-pages-succes-js" */),
  "component---src-templates-generic-page-js": () => import("./../../../src/templates/generic-page.js" /* webpackChunkName: "component---src-templates-generic-page-js" */),
  "component---src-templates-pack-js": () => import("./../../../src/templates/pack.js" /* webpackChunkName: "component---src-templates-pack-js" */)
}

